type AnalyticsValue = string | number | boolean | null | undefined;

export type AnalyticsProperties = Record<string, AnalyticsValue>;

function cleanProperties(
  properties?: AnalyticsProperties,
): Record<string, string | number | boolean | null> {
  if (!properties) return {};

  return Object.fromEntries(
    Object.entries(properties).filter(
      (entry): entry is [string, string | number | boolean | null] => entry[1] !== undefined,
    ),
  );
}

/**
 * Fires a custom Umami event. Safe no-op when `window.umami` isn't present
 * (dev/test, or prod with tracking disabled because `UMAMI_WEBSITE_ID`/
 * `UMAMI_SCRIPT_URL` are unset) — never throws, never logs.
 */
export function trackUmamiEvent(name: string, properties?: AnalyticsProperties) {
  if (typeof window === 'undefined' || !window.umami) return;

  window.umami.track(name, cleanProperties(properties));
}
